// Build-time settings injected by web/vite.config.ts from deploy.config.json.

declare const __APP_CONFIG__: { tenantId: string; clientId: string; apiBaseUrl: string };
declare const __MOCK__: boolean;

export const appConfig = __APP_CONFIG__;

/** True only under `npm run dev:mock`: synthetic data in the browser, no sign-in, no network. */
export const MOCK = __MOCK__;
